import { closeOtherDropdowns } from 'common-front/src/designSystem/components/dropdown/dropdown';
import { Box } from 'common/src/designSystem/components/box';
import { Cell } from 'common/src/designSystem/components/table/cell';
import { CellControls } from 'common/src/designSystem/components/table/cellControls';
import { HeaderCell } from 'common/src/designSystem/components/table/headerCell';
import { HeaderRow } from 'common/src/designSystem/components/table/headerRow';
import { Row } from 'common/src/designSystem/components/table/row';
import { RowSkeleton } from 'common/src/designSystem/components/table/rowSkeleton';
import { TableGrid } from 'common/src/designSystem/components/table/tableGrid';
import { RoleType } from 'common/src/generated/types';
import { useHistory, useParams, useTranslate } from 'common/src/util/dependencies/dependencies';
import { HeaventPaths } from 'common/src/util/paths/heaventPaths';
import * as React from 'react';
import { useRolesQuery } from '../../../generated/graphqlHooks';
import { useNotificationContext } from '../../../notifications/notificationContext';
import { Dropdown } from './dropdown/dropdown';

export const Table = () => {
    const { organizationId } = useParams();
    const translate = useTranslate();
    const history = useHistory();
    const { data, isLoading, reload } = useRolesQuery({
        organizationId,
        types: [RoleType.PositionEditor, RoleType.PositionReader, RoleType.Custom]
    });
    const { showNotification } = useNotificationContext();
    const onDelete = () => {
        showNotification({
            color: 'success',
            icon: 'circle-info',
            text: translate('le_r_le_a_bien_53462')
        });
        reload();
    };

    return (
        <TableGrid
            css={{
                height: 'auto',
                overflow: 'visible',
                '& > div:first-child': { borderRadius: '$2 $2 0 0' },
                '& > div:last-child': {
                    borderBottom: '1px solid $gray200',
                    borderRadius: '0 0 $2 $2'
                }
            }}
            headerRow={
                <HeaderRow>
                    <HeaderCell>{translate('nom_du_r_le_38492')}</HeaderCell>
                    <HeaderCell css={{ flexGrow: 2 }}>
                        {translate('description_du_94520')}
                    </HeaderCell>
                    <HeaderCell width={100} />
                </HeaderRow>
            }
        >
            {isLoading ? (
                <>
                    <RowSkeleton />
                    <RowSkeleton css={{ borderBottom: 'none' }} />
                </>
            ) : (
                data.organization.roles.map((role) => (
                    <Row
                        key={role.id}
                        css={{
                            cursor: 'pointer',
                            '&:hover': {
                                background: '$gray100'
                            },
                            '&:last-child': { borderBottom: 'none' }
                        }}
                        onClick={() => {
                            history.push(
                                HeaventPaths.EDIT_ORGANIZATION_PARAMETERS_ROLE(
                                    organizationId,
                                    role.id
                                )
                            );
                        }}
                        onMouseLeave={(e) => {
                            closeOtherDropdowns(e.target);
                        }}
                    >
                        <Cell
                            css={{
                                mindWidth: 0
                            }}
                        >
                            <Box ellipsis={true} title={role.name}>
                                {role.name}
                            </Box>
                        </Cell>
                        <Cell
                            css={{
                                flexGrow: 2,
                                minWidth: 0
                            }}
                        >
                            <Box ellipsis={true} title={role.description}>
                                {role.description}
                            </Box>
                        </Cell>
                        <CellControls justify="end">
                            <Dropdown role={role} onDelete={onDelete} />
                        </CellControls>
                    </Row>
                ))
            )}
        </TableGrid>
    );
};
